import { createReducer, on, Action } from "@ngrx/store";
import * as AlertActions from "../actions/alert.action";
import { IAlertState, initialAlertState } from "../state/alert.state";

export const alertsReducer = createReducer(
  initialAlertState,
  on(AlertActions.showAlertAction, (state: IAlertState, { payload }) => {
    return ({
        ...state,
        show: true,
        message: payload.message,
        title: payload.title,
        spaceId: payload.spaceId,
        bookingId: payload.bookingId,
        employeeId: payload.employeeId,
        deleteCompanyId: payload.deleteCompanyId,
        editSpaceId: payload.editSpaceId,
        editCompanyId: payload.editCompanyId,
        editCoworkingId: payload.editCoworkingId,
        optionOkText: payload.optionOkText,
        optionCancelText: payload.optionCancelText,
        action: payload.action,
        type: payload.type,
      }
    );
  }),
  on(AlertActions.closeAlertAction, (state: IAlertState) => {
    return ({
        ...state,
        show: false
      }
    );
  }),
  on(AlertActions.okAlertAction, (state: IAlertState, { action }) => {
    return ({
        ...state,
        action,
        show: false
      }
    );
  })
);

export function alertsReducers(state: IAlertState, action: Action) {
  return alertsReducer(state, action);
}
